const TARGET_LENGTH = 2;
const SECONDS_IN_MINUTE = 60;

export const date = {
    methods: {
        getDateFormatSearch: function(date) {
            if (date instanceof Date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(TARGET_LENGTH, '0');
                const day = String(date.getDate()).padStart(TARGET_LENGTH, '0');

                return `${year}-${month}-${day}`;
            }

            return date;
        },

        getDateTimeFormat: function(date = new Date()) {
            if (date instanceof Date) {
                const localeDate = date.toLocaleDateString();
                const localeTime = date.toLocaleTimeString();

                return `${localeDate}_${localeTime}`;
            }

            return date;
        },

        secondsToMinutes: function(seconds) {
            const minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
            const remainingSeconds = seconds % SECONDS_IN_MINUTE;
            const secondsString = String(remainingSeconds).padStart(TARGET_LENGTH, '0');

            return `${minutes}:${secondsString}`;
        },
    },
};